import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { SourceSelectionModalComponent } from './source-selection-modal/source-selection-modal.component';
import { SourceSelectionModalData } from './types';

@Injectable({
  providedIn: 'root',
})
export class ReviewSourceSelectionModalService {
  private readonly dialog = inject(MatDialog);

  openModal(input: SourceSelectionModalData): Observable<string[]> {
    return this.dialog
      .open(SourceSelectionModalComponent, {
        data: input,
        width: '100%',
        maxWidth: '698px',
        height: '100%',
        maxHeight: '714px',
      })
      .afterClosed();
  }
}
